import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useLeaguePolling } from 'app/hooks/useLeaguePolling';
import { selectMatches } from 'app/slice/selectors';
import navigationManager from 'routes/NavigationManager';
import { ROUTES } from 'routes/routes';
import Loader from 'components/Loader/Loader.style';
import { BLACK } from 'styles/colors';
import MatchNotFound from 'components/MatchNotFound';
import PageTitle from 'components/PageTitle';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import { Helmet } from 'react-helmet-async';
import { formatTs } from 'utils/utils';
import Badge from 'react-bootstrap/Badge';

const LeagueMatches: React.FC = () => {
  const { leagueId = '' } = useParams();
  const matches = useSelector(selectMatches);
  const { loading, error } = useLeaguePolling(leagueId);
  const initialLoadError = error && !matches;

  if (loading)
    return (
      <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <Loader color={BLACK} size={10} />
      </div>
    );

  if (initialLoadError) {
    return <MatchNotFound />;
  }

  return (
    <>
      <Helmet>
        <title>{leagueId}</title>
      </Helmet>
      <section>
        <PageTitle>
          <Badge bg="primary" className="me-1">
            {leagueId}
          </Badge>{' '}
          <Badge bg="light" text="dark">
            Mecze
          </Badge>
        </PageTitle>
        <Container className="pt-5 pb-5">
          <Row className="justify-content-center">
            <Col md={6}>
              {matches?.map((match) => {
                return (
                  <ListGroup key={match.id} className="mb-3">
                    <ListGroup.Item className="bg-dark text-light">
                      <div className="mb-0">
                        <span className="d-inline-block me-3">
                          <strong>{match.name}</strong>
                        </span>
                        <span className="d-inline-block">
                          <small>
                            {formatTs((match?.start_date || 0) * 1000)}
                          </small>
                        </span>
                      </div>
                    </ListGroup.Item>
                    {match.walls.map((wall) => {
                      const route = ROUTES.TV.replace(':leagueId', leagueId)
                        .replace(':matchId', match.id)
                        .replace(':wallId', wall.id);
                      const fullUrl = `${window.location.origin}${route}`;
                      return (
                        <>
                          <ListGroup.Item
                            key={`${match.league_id}_${match.id}_${wall.id}`}
                            action
                            href={fullUrl}
                            onClick={(
                              e: React.MouseEvent<HTMLAnchorElement>,
                            ) => {
                              e.preventDefault();
                              navigationManager.goTo(
                                `${route}?wallName=${wall.name}`,
                              );
                            }}
                          >
                            <div>
                              <span className="d-inline-block">
                                {wall.name}
                              </span>
                            </div>
                          </ListGroup.Item>
                        </>
                      );
                    })}
                  </ListGroup>
                );
              })}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default LeagueMatches;
